module.exports = __webpack_public_path__ + "media/images/forms-icons/tabular-data-icon-7f5c716437e111d9ec13c704f5a504ea.svg";